import React, {useMemo} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {AddOutlined, DeleteOutlined, EditOutlined} from '@material-ui/icons';
import PageWrapper from '../../../shared/pagewrapper/PageWrapper.js';
import PageTitle from '../../../shared/pagetitle/PageTitle.js';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import BlockUI from '../../../shared/blockui/BlockUI.tsx';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import {criarColunaOpcoes} from '../../components/ColunaOpcoes.jsx';
import DialogCoordenador from '../../dialogs/cadastro/DialogCoordenador.jsx';
import FotoPessoa from '../../components/cadastro/FotoPessoa.jsx';
import useCadastroBasico from '../../components/cadastro/useCadastroBasico.js';
import {formatarDataIso} from '../../components/cadastro/cadastroAtendimento.js';
import {ouTraco} from '../../components/inscricao/documentoInscricao.js';
import PageNaoEncontrada from '../../../PageNaoEncontrada.jsx';
import useCheckModule from '../../../../hooks/useCheckModule.js';
import {MODULOS_CADASTROS, URL_COORDENADORES} from '../../../../constants/index.js';
import {buttonTableCell, containerPaper} from '../../../../utils/styles.js';
import {PAGINACAO_PADRAO, textoSemRegistros} from '../../components/paginacao.js';

const FILTER_OPTIONS = {filterByColumn: true};
const TABLE_CONTAINER_PROPS = {component: 'div'};

const useStyles = makeStyles(theme => ({
    ...containerPaper(theme),
    colunaFoto: {
        width: theme.spacing(9)
    },
    colunaData: {
        width: theme.spacing(16)
    },
    ...buttonTableCell(theme)
}));

/*
 * Coordenadores da Central de Bolsas: lista com filtro por coluna e paginação, e
 * criação/edição em diálogo. Não tem módulo próprio: libera para quem tem qualquer
 * módulo de cadastro (como o submenu Cadastro do PrimeFaces).
 */
export default function PageCoordenadores() {
    const classes = useStyles();
    const checkModule = useCheckModule();
    const podeAcessar = MODULOS_CADASTROS.some(modulo => checkModule(modulo));
    const {
        itens,
        carregando,
        salvando,
        dialogAberto,
        fecharDialog,
        itemEmEdicao,
        adicionar,
        editar,
        salvar,
        excluir
    } = useCadastroBasico({url: URL_COORDENADORES, nomeItem: 'Coordenador', habilitado: podeAcessar});

    // O nome do campus vem aninhado; achatado para o filtro por coluna do DataGrid.
    const linhas = useMemo(
        () => itens.map(item => ({...item, campusNome: item.campus ? item.campus.nome : null})),
        [itens]);

    if (!podeAcessar) {
        return <PageNaoEncontrada/>;
    }

    return (
        <PageWrapper>
            <PageTitle title='Coordenadores Central de Bolsas'/>
            <Paper className={classes.containerPaper}>
                <BlockUI loading={carregando}>
                    <DataGrid
                        rows={linhas}
                        comparatorKeys={['id']}
                        filterOptions={FILTER_OPTIONS}
                        paginate
                        paginateOptions={PAGINACAO_PADRAO}
                        tableContainerProps={TABLE_CONTAINER_PROPS}
                        noRecordsText={textoSemRegistros(carregando)}
                        toolbarContent={(
                            <ContainedButton startIcon={<AddOutlined/>} onClick={adicionar}>
                                Adicionar
                            </ContainedButton>
                        )}
                        columns={[
                            {
                                label: 'Foto',
                                filterable: false,
                                className: classes.colunaFoto,
                                valueGetter: (valor, row) => <FotoPessoa urlFoto={row.urlFoto} nome={row.nome}/>
                            },
                            {label: 'Responsável', field: 'nome', filterable: true, valueGetter: valor => ouTraco(valor)},
                            {label: 'Cargo', field: 'cargo', filterable: true, valueGetter: valor => ouTraco(valor)},
                            {label: 'Campus', field: 'campusNome', filterable: true, valueGetter: valor => ouTraco(valor)},
                            {
                                label: 'Início vigência',
                                field: 'dataInicioVigencia',
                                filterable: false,
                                className: classes.colunaData,
                                valueGetter: valor => ouTraco(formatarDataIso(valor))
                            },
                            {
                                label: 'Fim vigência',
                                field: 'dataFimVigencia',
                                filterable: false,
                                className: classes.colunaData,
                                valueGetter: valor => ouTraco(formatarDataIso(valor))
                            },
                            criarColunaOpcoes(row => [
                                {titulo: 'Editar', icone: <EditOutlined/>, onClick: () => editar(row)},
                                {titulo: 'Excluir', icone: <DeleteOutlined/>, onClick: () => excluir(row)}
                            ], {className: classes.buttonTableCell})
                        ]}/>
                </BlockUI>
            </Paper>
            <DialogCoordenador
                open={dialogAberto}
                onClose={fecharDialog}
                item={itemEmEdicao}
                salvando={salvando}
                onSalvar={salvar}/>
        </PageWrapper>
    );
}
